<template>
  <div v-if="sourceType === FeedContentSourceType.BKK" class="text-sm pb-2">
    {{ t("article.card.sourcetype.bkk.label") }}
  </div>
  <div
    v-else-if="sourceType === FeedContentSourceType.COMPANY"
    class="text-sm pb-2"
  >
    {{ t("article.card.sourcetype.work.label") }}
  </div>
  <div v-else class="pb-2">&nbsp;</div>
  <div
    class="cursor-pointer pb-2 flex flex-col justify-center"
    @click="goToArticle"
  >
    <img
      :src="imageUrl"
      :alt="imageAltText"
      class="rounded-xl mb-2 h-[320px] object-cover"
    />
    <h3 class="text-large leading-snug mb-1 line-clamp-2">
      {{ title }}
    </h3>
  </div>

  <div class="mt-auto flex gap-2">
    <BaseButton
      class="w-36 h-10 pr-1.5"
      :borderless="true"
      @click="goToArticle"
    >
      <div class="flex flex-row justify-between items-center w-full">
        <span>{{ t("cta.open.article") }}</span>
        <div class="bg-white rounded-full p-1"><ArrowRight /></div>
      </div>
    </BaseButton>
    <SmallIconButton
      v-if="!isFavoriteState"
      variant="white"
      class="!w-10 !h-10"
      @click="addFavorite"
    >
      <FavoriteIcon class="w-7 h-7" />
    </SmallIconButton>
    <SmallIconButton
      v-else
      variant="white"
      class="!w-10 !h-10"
      @click="removeFavoriteModal = true"
    >
      <FavoritedIcon class="w-7 h-7" />
    </SmallIconButton>
  </div>
  <RemoveFavoriteModal
    :open="removeFavoriteModal"
    @remove-favorite="removeFavorite"
    @close="removeFavoriteModal = false"
  />
</template>
<script setup lang="ts">
import SmallIconButton from "../layout/button/SmallIconButton.vue";
import BaseButton from "../layout/button/BaseButton.vue";
import FavoriteIcon from "../icon/FavoriteIcon.vue";
import FavoritedIcon from "../icon/FavoritedIcon.vue";
import RemoveFavoriteModal from "./RemoveFavoriteModal.vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { FeedContentSourceType } from "../../../enum/v2/feed-content-source-type";
import {
  MATOMO_CATEGORY_CLICK,
  MATOMO_EVENT_KEY_ARTICLE_BOOKMARK,
  resolveKey,
} from "../../../enum/v2/matomoType";
import { favoriteArticle, removeFavoriteArticle } from "../../../api/v2/feed";
import { useUserStore } from "../../../store/v2/user";

const { t } = useI18n();
const router = useRouter();
const userStore = useUserStore();
const emit = defineEmits(["remove-favorite"]);

const props = defineProps<{
  title: string;
  imageUrl: string;
  imageAltText: string;
  articleId: string;
  sourceType: string;
  teaser: string;
  isFavorite: boolean;
  origin?: string | null;
}>();

const isFavoriteState = ref(props.isFavorite);
const removeFavoriteModal = ref(false);

function goToArticle() {
  router.push({
    name: "article",
    params: { id: props.articleId },
    state: { origin: props.origin },
  });
}

import { inject } from "vue";
import ArrowRight from "../icon/ArrowRight.vue";

const matomo = inject<any>("matomo");

function addFavorite() {
  isFavoriteState.value = true;
  favoriteArticle(props.articleId, userStore.getExternalUserId);
}

function removeFavorite() {
  removeFavoriteArticle(props.articleId, userStore.getExternalUserId);
  removeFavoriteModal.value = false;
  isFavoriteState.value = false;
  emit("remove-favorite");
}
</script>
